import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import ptBrExtra from '@angular/common/locales/extra/pt';
import enUs from '@angular/common/locales/en';
import enUsExtra from '@angular/common/locales/extra/en';

// Registrar locales
registerLocaleData(ptBr, 'pt-BR', ptBrExtra);
registerLocaleData(enUs, 'en-US', enUsExtra);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
